"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { SiteRoutedPage } from './deskUi/SiteRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function SiteSurfaceClient(props: DeskSurfaceClientProps) {
  return (
    <MsgDeskSurfaceClient
      {...props}
      RoutedPage={SiteRoutedPage}
      Loading={MsgDeskLoading}
      loadInitialSubsOnMsgRoute={false}
    />
  )
}
